module.exports = __webpack_public_path__ + "static/media/logo-tableau.67935d87.png";